import React from 'react'
import {
  ListProps,
  Pagination,
  TextField,
  TextInput,
  useListContext,
  Filter,
  Datagrid,
} from 'react-admin'
import List from '../../common/customized-ra-components/List'
import FilterProps from '../../common/FilterProps'

const FilesFilters = (props: FilterProps) => (
  <Filter {...props}>
    <TextInput source="name" alwaysOn autoFocus />
    <TextInput source="path" />
  </Filter>
)

export const FilesList = ({ ...props }: ListProps) => {
  const { loading } = useListContext()

  return (
    <List
      {...props}
      perPage={20}
      pagination={<Pagination rowsPerPageOptions={[10, 20, 50, 100, 200]} />}
      exporter={false}
      filters={<FilesFilters />}
      bulkActionButtons={false}
    >
      <Datagrid size="small" loaded={!loading}>
        <TextField source="id" label="ID" />
        <TextField source="name" />
        <TextField source="path" />
      </Datagrid>
    </List>
  )
}
